<template>
  <div class="consent-form">
    <!-- TODO: check how is this working in lpv2 -->
    <div :key="$i18n.locale" class="consent-text">
      <h3>{{ termData.title }}</h3>
      <p class="consent-offer">{{ $t('consent_offer') }}</p>
      <p>{{ termData.description }}</p>
      <div class="button-area">
        <button class="consent-button wide" :style="yesButtonStyles" @click="getUpdates()">
          {{ termData.yesText }}
        </button>
        <button
          class="consent-button wide black"
          :style="noTextStyles"
          @click.prevent="getNoUpdates()"
        >
          {{ termData.noText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import AcceptTerms from '../components/terms/terms-conditions.vue'
  import { logUserAction } from '../utils/logging'
  import screens from '../utils/pageSchema'
  export default {
    components: {
      AcceptTerms,
    },
    props: ['wftkn', 'preview'],
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      yesButtonStyles() {
        return {
          background: this.baseData.colors.primaryBtn || '#55acee',
          color: this.baseData.colors.primaryBtnText || 'white',
        }
      },
      noTextStyles() {
        return {
          background: this.baseData.colors.primaryBtn || '#55acee',
          color: this.baseData.colors.primaryBtnText || 'white',
        }
      },
      termData() {
        const data = this.baseData.i18n && this.baseData.i18n[this.$i18n.locale]
        const isPlume = this.$store.state.isPlume
        if (isPlume) {
          return {
            title: this.$t('consent_opt_in_text'),
            description: this.$t('consent_opt_in_description'),
            noText: this.$t('consent_no_text'),
            yesText: this.$t('consent_yes_text'),
          }
        }
        return {
          title: (data && data.consent_opt_in_text) || this.$t('consent_opt_in_text'),
          description:
            (data && data.consent_opt_in_description) || this.$t('consent_opt_in_description'),
          noText: (data && data.consent_no_text) || this.$t('consent_no_text'),
          yesText: (data && data.consent_yes_text) || this.$t('consent_yes_text'),
        }
      },
    },
    methods: {
      async getNoUpdates() {
        logUserAction({ type: 'user_action', label: 'User Disagreed to Terms and Conditions' })
        await this.$store.dispatch('agreeConsent', { wftkn: this.wftkn, consent: 0 })
        this.$store.commit('skipToFreeWifi')
        await screens.advance()
      },
      async getUpdates() {
        logUserAction({ type: 'user_action', label: 'User Agreed to Terms and Conditions' })
        await this.$store.dispatch('agreeConsent', { wftkn: this.wftkn, consent: 1 })
        await screens.advance()
      },
    },
  }
</script>

<style scoped>
  .consent-form {
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 30px;
  }
  .consent-form .consent-text {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .consent-form .consent-button {
    background: #55acee;
    border: none;
    border-radius: 32px;
    padding: 10px 20px;
    color: white;
    font-size: 14px;
    transition: 0.3s all;
    cursor: pointer;
  }
  .consent-form .consent-button:hover {
    opacity: 0.8;
  }
  .consent-form .black {
    margin: 10px 0;
    display: inline-block;
  }
  .consent-form h3 {
    text-align: center;
    padding: 0 10px;
  }

  .consent-form p {
    text-align: center;
    margin-top: -10px;
  }
  .consent-form .consent-button.wide {
    width: 100%;
    font-size: 16px;
    padding: 15px 20px;
    max-width: 200px;
  }
  .consent-form .button-area {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .consent-offer {
    margin-bottom: 20px;
    padding-inline: 20px;
  }
</style>
<style>
  .consent-form .consent-terms.terms p.anchor {
    font-size: 12px;
  }
</style>
